// client/src/components/donations/MemberGiving.jsx
//
// Giving on a member's profile (Roadmap Phase 5.1): lifetime total, monthly
// gifts, recent gifts. Matched by the member id or their email. Hidden when
// donations aren't set up, the person has never given, or the viewer's role
// can't see donations.

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getGiving, formatMoney } from '../../services/donationsApi';

function day(value) {
  if (!value) return '';
  const s = String(value);
  const d = new Date(s.includes('T') ? s : `${s.replace(' ', 'T')}Z`);
  return Number.isNaN(d.getTime()) ? s : d.toLocaleDateString();
}

export default function MemberGiving({ tenantId, memberId, email }) {
  const { t } = useTranslation();
  const [giving, setGiving] = useState(null);

  useEffect(() => {
    if (!tenantId || (!memberId && !email)) return undefined;
    let alive = true;
    getGiving(tenantId, { memberId, email })
      .then((g) => { if (alive) setGiving(g.ready === false ? null : g); })
      .catch(() => { if (alive) setGiving(null); });
    return () => { alive = false; };
  }, [tenantId, memberId, email]);

  if (!giving || !giving.giftCount) return null;
  const currency = (giving.gifts[0] && giving.gifts[0].currency) || 'usd';
  return (
    <section className="surface" data-testid="member-giving" style={{ marginTop: 16 }}>
      <h3 style={{ marginTop: 0 }}>{t('donations.member.title', 'Giving')}</h3>
      <p style={{ margin: '0 0 8px' }}>
        <strong>{t('donations.member.total', '{{amount}} given in {{count}} gifts', { amount: formatMoney(giving.totalCents, currency), count: giving.giftCount })}</strong>
        {giving.firstGiftOn && <> · {t('donations.member.since', 'since {{date}}', { date: day(giving.firstGiftOn) })}</>}
      </p>
      {giving.monthly.map((m) => (
        <p key={m.id} style={{ margin: '0 0 8px' }}>
          {t('donations.member.monthly', 'Gives {{amount}} every month', { amount: formatMoney(m.amountCents, m.currency) })}
          {m.status === 'past_due' && <> · {t('donations.status.pastDue', 'Payment failed')}</>}
        </p>
      ))}
      <ul style={{ margin: 0, paddingLeft: 18 }}>
        {giving.gifts.slice(0, 5).map((g) => (
          <li key={g.id}>
            {day(g.completedOn)} · {formatMoney(g.amountCents, g.currency)} · {g.pageTitle}
            {g.status === 'refunded' && <> · {t('donations.status.refunded', 'Refunded')}</>}
          </li>
        ))}
      </ul>
    </section>
  );
}
